module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_stone_ppl-f726d0dbf0faa63f212155e9b1608a72.png";